import { Button } from 'components/button/Button'
import { SGalleryActionsWrapper } from './SelectFromGalleryModal.styled'
import { Icon } from 'components/icon'
import { useWindowSize } from 'utils/hooks'

export function SelectFromGalleryModalActions(props: {
  onTakeSelfiePress: () => void
  onUploadPhotoPress: () => void
}) {
  const { isDesktop } = useWindowSize()
  return (
    <SGalleryActionsWrapper>
      <Button
        type="submit"
        variant="text"
        leftIcon={<Icon name="Camera" />}
        onClick={props.onTakeSelfiePress}
      >
        {isDesktop ? 'Take a selfie' : 'Take selfie'}
      </Button>
      <Button
        type="submit"
        variant="text"
        leftIcon={<Icon name="FileUpload" />}
        onClick={props.onUploadPhotoPress}
      >
        {isDesktop ? 'Upload a photo' : 'Upload photo'}
      </Button>
    </SGalleryActionsWrapper>
  )
}
